<template>
  <div class="all-style-bgc">
      <div class="text" >
      
        <h1>生活用水常识</h1>
        
        
        <div class="textContent">
          <h3>水是生命的源泉，生活离不开水，应重视用水安全。 <br/></h3>
（1）注意保持饮用水清洁卫生，发现饮用水变色、变浑、变味。应立即停止引用，防止中毒。 <br/>
（2）不得私自挪动供水设施，尤其不得私自移动水表。 <br/>
（3）如装修改造用水设施，应选用饮用水专用管材，改造后做打压试验。 <br/>
（4）定期自检用水设施，关闭用水阀门后如出现水表自走，说明漏水。 <br/>
（5）寒冷季节，应对用水设施采取必要的防冻保护措施。室内无取暖设施的，应在夜间或长期不用水时关闭走廊和室内门窗，保持室温；同时关闭户内水表阀门，打开水龙头，放净水管中积水；室外水管、阀门可用棉、麻织物或保暖材料帮扎保暖，以防冻裂损坏。 <br/>
（6）长期无人居住的房屋，应到辖区自来水公司营业站点办理暂停用水手续，并关闭用水阀门；将自家的电话号码留给邻居或物业公司，以便情况紧急时联系。 <br/>
（8）虽然表面上看起来河水、湖水、溪水、塘水很干净，实际上可能水中含有微生物、寄生虫卵或有毒化学物质，人们饮用未经消毒处理的水，就有可能染上腹泻、痢疾、甲肝等疾病；受地质结构的影响，某些地区的饮水中氟、砷含量过高，人们长期喝这样的水，就会患氟中毒和砷中毒等地方病。<br/>
        </div>
        
        
      </div>
  </div>
</template>

<script>
import util from '@/utils/util'
import { doUserScore } from '@/api/Hall/xagl'

export default {
  props: {
    loading: {
      default: false
    },
    visible: {}
  },
  data() {
    return {
    }
  },
  computed: {
    visibleChange: {
      get: function() {
        return this.visible
      },
      // 子组件参数变动需通过此方法传递到父组件进行数据更新
      set: function(newValue) {
        this.$emit('on-visible', newValue)
      }
    }
  },
  methods: {
    
    // 请求创建
  }
}
</script>

<style >
.commPage {
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.container {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  margin-top: 6px;
}
.content {
  width: 1200px;
  min-height: 300px;
  background-color: white;
  box-sizing: border-box;
  padding: 26px 40px;
}
.text {
  background-color: white;
  padding: 20px;
}
.text > h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text > h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
}
.text > h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  margin-bottom: 38px;
}
.textContent{
  font-size: 18px;
  line-height: 35px;
}
</style>
